// extracted by mini-css-extract-plugin
module.exports = {"vantageBlue":"#3f1f5a"};